module.exports = __webpack_public_path__ + "img/5.884ee5d7.png";